module.exports = __webpack_public_path__ + "static/media/darkBg.930a1ab0.png";